export default __webpack_public_path__ + "static/media/PrettyPalms-logo-no Background.5bc1e44e.png";